export const DISABLE_PULL_TO_REFRESH = "DISABLE_PULL_TO_REFRESH";
export const GET_BOUNCE = "GET_BOUNCE";
export const SET_ACTIVE_BREAKPOINT = "SET_ACTIVE_BREAKPOINT";
export const TOGGLE_SIDEDRAWER = "TOGGLE_SIDEDRAWER";
export const TOGGLE_SOUND = "TOGGLE_SOUND";
export const VIDEO_IS_LOADED = "VIDEO_IS_LOADED";

export const GET_CONTENT = "GET_CONTENT";
export const INIT_DATA = "INIT_DATA";
export const FETCH_DATA_START = "FETCH_DATA_START";
export const SET_DATA = "SET_DATA";
export const FETCH_DATA_FAILED = "FETCH_DATA_FAILED";
export const NAVIGATION_CLICKED = "NAVIGATION_CLICKED";
export const NAVIGATION_FINISHED = "NAVIGATION_FINISHED";
export const SET_MEDIA_LOADED = "SET_MEDIA_LOADED";
export const SET_SCROLL_DIRECTION = "SET_SCROLL_DIRECTION";
export const SCROLL_CLICKED = "SCROLL_CLICKED";
export const SCROLL_FINISHED = "SCROLL_FINISHED";


// WEBPACK FOOTER //
// ./src/store/actions/actionTypes.tsx